<template>
  <div class="portfolio_page">
    <a-row>
      <a-col :span="15">
        <div class="portfolio_data">
          <a-button type="link" @click="goBack"> <a-icon type="left" />返回</a-button>
          <div class="layout_btn">
            <template v-if="isEdit">
              <a-button type="link" @click="cancelConfigEdit" class="cancel_btn"> 取消 </a-button>
              <a-button type="link" @click="saveConfigEdit" class="save_btn"> 保存 </a-button>
            </template>
            <div v-else>
              <a-button type="link" @click="editPortfoConfig" class="save_btn" v-show="btnPermission.includes('update')"> 编辑 </a-button>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content">
              <div v-if="isEdit && tags.length > 0" class="item-title" style="padding-bottom: 42px">常用名</div>
              <div v-else class="item-title">常用名</div>
              <div class="item-content" v-if="isEdit">
                <div v-if="tags.length > 0">
                  <template v-for="tag in tags">
                    <a-tag :key="tag" closable @close="() => handleClose(tag)">
                      {{ tag }}
                    </a-tag>
                  </template>
                  <div style="padding-top: 10px"></div>
                </div>
                <a-input @pressEnter="handleInputConfirm" :value="inputValue" @change="handleInputChange" placeholder="按下Enter可添加多个常用名"></a-input>
              </div>
              <div class="item-content" v-else>{{ oldName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content">
              <div class="item-title">LP报告-项目名称(中)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="lpName"></a-input></div>
              <div class="item-content" v-else>{{ lpName }}</div>
            </div>
            <div class="portfolio_content">
              <div class="item-title">LP报告-项目名称(En)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="lpEnName"></a-input></div>
              <div class="item-content" v-else>{{ lpEnName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content">
              <div class="item-title">官网名称(关于我们)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="sccAboutName"></a-input></div>
              <div class="item-content" v-else>{{ sccAboutName }}</div>
            </div>
            <div class="portfolio_content">
              <div class="item-title">官网名称(成员企业)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="sccCompanyName"></a-input></div>
              <div class="item-content" v-else>{{ sccCompanyName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content">
              <div class="item-title">源码赛道(中)</div>
              <div class="item-content" v-if="isEdit">
                <a-select @change="handleIndustryChange" v-model="industrySelected">
                  <a-select-option v-for="item in industryList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </div>
              <div class="item-content" v-else>{{ industryName }}</div>
            </div>
            <div class="portfolio_content">
              <div class="item-title">源码赛道(En)</div>
              <div class="item-content">{{ industryEnName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content">
              <div class="item-title">项目简介(中)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="description"></a-input></div>
              <div class="item-content" v-else>{{ description }}</div>
            </div>
            <div class="portfolio_content">
              <div class="item-title">项目简介(En)</div>
              <div class="item-content" v-if="isEdit"><a-input v-model="descriptionEn"></a-input></div>
              <div class="item-content" v-else>{{ descriptionEn }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content item_layout">
              <div class="item-title">官网-成员企业介绍</div>
              <div class="item-content" v-if="isEdit">
                <a-textarea v-model="sccDetail" :autoSize="{ minRows: 6, maxRows: 6 }"></a-textarea>
              </div>
              <div class="item-content" v-else>{{ sccDetail }}</div>
            </div>
          </div>
          <div class="item">
            <div class="portfolio_content item_layout">
              <div class="item-title">备注</div>
              <div class="item-content" v-if="isEdit">
                <a-textarea v-model="remark" :autoSize="{ minRows: 6, maxRows: 6 }"></a-textarea>
              </div>
              <div class="item-content" v-else>{{ remark }}</div>
            </div>
          </div>
        </div>
      </a-col>
      <!-- </div> -->
      <a-col :span="1"> </a-col>
      <a-col :span="8">
        <div class="record">
          <span class="record_title">维护记录</span>
          <div class="record_item" v-for="(item, index) in logs" :key="index">
            <div v-html="item"></div>
          </div>
          <div></div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { portfolioQuery, savePortfolio } from '@/api/project';
import { getCommonList } from '@/api/common';
import Event from '@/utils/event';

export default {
  name: 'portfolioConfig',
  props: ['companyId'],
  data() {
    return {
      oldName: '',
      lpName: '',
      lpEnName: '',
      sccAboutName: '',
      sccCompanyName: '',
      industryName: '',
      industryEnName: '',
      description: '',
      descriptionEn: '',
      sccDetail: '',
      logs: '',
      isEdit: false,
      industryList: '',
      industrySelected: '',
      remark: '',
      tags: '',
      inputValue: ''
    };
  },
  methods: {
    editPortfoConfig() {
      this.isEdit = true;
    },
    async saveConfigEdit() {
      try {
        let industry = '';
        if (this.industry) {
          industry = this.industry.id;
        }
        if (this.inputValue !== '') {
          this.tags = [...this.tags, this.inputValue];
          this.inputValue = '';
        }
        if (this.tags.length !== 0) {
          this.oldName = this.tags.join('，');
        } else {
          this.oldName = '';
        }
        let data = {
          companyId: this.companyId,
          oldName: this.oldName,
          lpName: this.lpName,
          lpEnName: this.lpEnName,
          sccAboutName: this.sccAboutName,
          sccCompanyName: this.sccCompanyName,
          industry: industry,
          description: this.description,
          descriptionEn: this.descriptionEn,
          sccDetail: this.sccDetail,
          remark: this.remark
        };
        let res = await savePortfolio(data);
        if (res.code === 200) {
          //保存成功
          let data = await portfolioQuery({ companyId: this.companyId });
          this.logs = data.data.logs;
          this.$message.success('保存成功');
          this.isEdit = false;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleIndustryChange(index) {
      this.industry = this.industryList.find(e => {
        return e.id === index;
      });
      this.industryName = this.industry.name;
      this.industryEnName = this.industry.enName;
    },
    cancelConfigEdit() {
      this.portfolioQuery();
      this.isEdit = false;
    },
    async portfolioQuery() {
      try {
        await this.getIndustryList();
      } catch (err) {
        console.log(err);
      }
      try {
        let res = await portfolioQuery({ companyId: this.companyId });
        if (res.code === 200) {
          let { oldName, lpName, lpEnName, sccAboutName, sccCompanyName, industry, description, descriptionEn, sccDetail, logs, remark } = res.data;
          this.oldName = oldName;
          this.lpName = lpName;
          this.lpEnName = lpEnName;
          this.sccAboutName = sccAboutName;
          this.sccCompanyName = sccCompanyName;
          this.description = description;
          this.descriptionEn = descriptionEn;
          this.sccDetail = sccDetail;
          this.remark = remark;
          this.logs = logs;
          if (oldName !== '') {
            this.tags = oldName.split('，');
          }
          this.industry = this.industryList.find(e => {
            return e.id === industry;
          });
          if (this.industry) {
            this.industryName = this.industry.name;
            this.industryEnName = this.industry.enName;
            this.industrySelected = this.industry.id;
          }
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getIndustryList() {
      try {
        const res = await getCommonList();
        if (res.code === 200) {
          this.industryList = res.data.industry;
        }
      } catch (err) {
        console.log(err);
      }
    },
    goBack() {
      Event.$emit('toInfoDetail', 0);
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      this.tags = tags;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      Object.assign(this, {
        tags,
        inputValue: ''
      });
    }
  },
  created() {
    this.portfolioQuery();
  },
  computed: {
    btnPermission() {
      try {
        const userInfo = this.$store.getters.userInfo;
        const pageInfo = userInfo.permissions.filter(item => item.fullPath === '/project');
        const actions = pageInfo[0].children.filter(item => item.type === 1).map(item => item.value);
        return actions;
      } catch (error) {
        return [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.portfolio_page {
  .portfolio_data {
    border: 1px solid #f0f2f5;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 40px;
    .layout_btn {
      float: right;
      margin-right: 5px;
    }
    .cancel_btn {
      color: #999;
      padding: 0;
      margin-right: 10px;
    }
    .save_btn {
      padding: 0;
      margin-right: 10px;
    }
    .ant-input {
      width: 400px;
    }
    .ant-select {
      width: 400px;
    }
    .item {
      padding-top: 20px;
      .portfolio_content {
        display: flex;
        align-items: center;
        margin-top: 16px;
        padding-bottom: 20px;
        .item-title {
          min-width: 200px;
          width: 200px;
          font-size: 14px;
          text-align: right;
        }
        .item-content {
          margin-left: 50px;
          min-width: 500px;
          width: 500px;
          font-size: 14px;
          text-align: left;
          word-wrap: break-word;
        }
      }
      .item_layout {
        display: flex;
        align-items: flex-start;
      }
    }
  }
  .record {
    padding: 15px;
    border: 1px solid #f0f2f5;
    border-radius: 5px;
    margin-bottom: 40px;
    .record_title {
      font-weight: bold;
      margin: 20px 0 0 10x;
    }
    .record_item {
      margin-top: 15px;
      font-weight: normal;
      word-break: break-all;
    }
  }
}
</style>
